import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import {getColumnOptionDatas} from 'insights/analytics-visualizations/configs/config-components/ConfigEditorUtils';
import DropdownSelector from 'insights/analytics-visualizations/configs/form-components/DropdownSelector';
import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface DataFrameSharedPopoverProps {
  canSelectColumn?: boolean;
  columns: Array<DataFrameColumnDef>;
  onCancel?: () => void;
  onSave?: () => void;
  selectedColumnSystemName: string;
  onColumnSystemNameChange: (columnSystemName: string) => void;
  internalCreator: JSX.Element;
  isDisabled: boolean;
}

/**
 * Create a popover for a column transformation.
 */
export function DataFrameSharedPopover({
  canSelectColumn,
  columns,
  onCancel,
  onSave,
  selectedColumnSystemName,
  onColumnSystemNameChange,
  internalCreator,
  isDisabled,
}: DataFrameSharedPopoverProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'DataFrameSharedPopover', element: 'root'})}>
      {canSelectColumn && (
        <div className={css(styles.columnSelector)}>
          <FieldLabel label="Column to transform" />
          <DropdownSelector
            allowNull={false}
            onChange={onColumnSystemNameChange}
            searchable={true}
            selectedValue={selectedColumnSystemName}
            optionDatas={getColumnOptionDatas(
              columns.filter((column) => selectedColumnSystemName === column.systemName || canSelectColumn),
              true
            )}
          />
        </div>
      )}
      {internalCreator}
      <div className={css(styles.buttonContainer)}>
        <div className={css(styles.button)}>
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            size={ButtonSize.SMALL}
            text="Apply"
            onClick={onSave}
            disabled={isDisabled}
            dataTestAttrs={{component: 'DataFrameSharedPopover', element: 'applyButton'}}
          />
        </div>
        <div className={css(styles.button)}>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            text="Cancel"
            onClick={onCancel}
          />
        </div>
      </div>
    </div>
  );
}

export const styles = StyleSheet.create({
  button: {
    marginLeft: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginTop: 5,
  },
  columnSelector: {
    marginBottom: 15,
  },
  chip: {
    minWidth: 125,
  },
});
